/**
 * created by wang lei
 超链接页面
 *
 */
import React, {Component} from 'react';
import hyperlink from './hyperlink.png';
import {Modal, Input, Checkbox} from 'antd';
import $ from "jquery";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class HyperlinkTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            content:"",
            href:"",
            title:"",
            openNew:false,
            hideHyperToolContent: false
        }
    }

    resetValue=()=>{
        this.state.content = "";
        this.state.href = "";
        this.state.title = "";
        this.state.openNew = false;
    };

    click=()=>{
        this.state.hideHyperToolContent = this.props.hideHyperToolContent || (this.props.editor && this.props.editor.dataType === "rmapp");
        this.setState({visible:true});
        let linkInfo = window.ueditor.queryCommandValue( 'link' );
        this.resetValue();
        if(linkInfo){
            let title = $(linkInfo).attr("title");
            title && (this.state.title = title);

            let target = $(linkInfo).attr("target");
            this.state.openNew = target === "_blank";

            let href = $(linkInfo).attr("href");
            href && (this.state.href = href);

            let content = $(linkInfo).text();
            content && (this.state.content = content);
        }
        this.setState({});
    }

    render() {
        return (
            <>
                <span style={{cursor:"pointer"}} onClick={()=>{
                    this.click()
                }}>
                    <img className={"editor-hyper-link-tool-btn"} src={hyperlink}/>
                    <style>{`
                .editor-hyper-link-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-hyper-link-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-hyper-link-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
                </span>
                <Modal
                    visible={this.state.visible}
                    title={"超链接"}
                    width={550}
                    onOk={()=>{
                        let href = this.state.href;
                        if(!href.startsWith("http://") && !href.startsWith("https://")){
                            href = "http://" + href;
                        }
                        window.ueditor.execCommand( 'link', {href,title:this.state.title,target:this.state.openNew?"_blank":"",textValue:this.state.content} );
                        this.setState({visible:false});
                    }}
                    maskClosable={false}
                    onCancel={()=>this.setState({visible:false})}
                >
                    <table cellSpacing={0} cellPadding={0} border={0} width={"100%"}><tbody>
                        <tr style={{lineHeight:3}}>
                            <td width={80}>文本内容：</td>
                            <td><Input value={this.state.content} onChange={e=>this.setState({content:e.target.value})}
                                       ref={content=> this.contentComponent = content} /></td>
                        </tr>
                        <tr style={{lineHeight:3}}>
                            <td>链接地址：</td>
                            <td><Input value={this.state.href} onChange={e=>this.setState({href:e.target.value})}
                                       ref={href=>this.hrefComponent = href} /></td>
                        </tr>
                        {this.state.hideHyperToolContent ? null :
                        <tr style={{lineHeight:3}}>
                            <td>标题：</td>
                            <td><Input value={this.state.title} onChange={e=>this.setState({title:e.target.value})}
                                       ref={title => this.titleComponent = title} /></td>
                        </tr>}
                        {this.state.hideHyperToolContent ? null :
                        <tr style={{lineHeight:2.5}}>
                            <td colSpan={2}>是否在新窗口打开：<Checkbox checked={this.state.openNew}
                                                               onChange={e=>this.setState({openNew:e.target.checked})}
                                                               ref={target=>this.targetComponent = target} /></td>
                        </tr>}
                        <tr style={{lineHeight:2.5}}>
                            <td colSpan={2} style={{color:"red"}}>您输入的超链接中不包含http等协议名称，默认将为您添加http://前缀</td>
                        </tr>
                    </tbody></table>
                </Modal>
            </>
        )
    }

}